// extracted by mini-css-extract-plugin
export default {"loader":"payment_loader__RhDO8","spin":"payment_spin__5Xkq9"};